import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import axios, { AxiosResponse } from 'axios';
import useQueryParam from '@src/shared/hooks/use-queryparam';
import { languageQueryParam } from '@src/i18n';
import useStyles from './styles';
export const JetCourierTechListing = () => {
  const [content, setContent] = useState('');
  const { params } = useQueryParam(languageQueryParam);
  const defaultLang = 'en';
  const existingPrivacyStatementLanguagesList = ['en'];
  const classes = useStyles();

  useEffect(() => {
    if (params) {
      const privacyFileLanguage = existingPrivacyStatementLanguagesList.includes(params)
        ? params
        : defaultLang;
      axios
        .get(`/jetcourier_tech_listing_docs/jetcourier_tech_listing_${privacyFileLanguage}.md`)
        .then((response: AxiosResponse) => {
          setContent(response.data);
        });
    } else {
      axios
        .get(`/jetcourier_tech_listing_docs/jetcourier_tech_listing_${defaultLang}.md`)
        .then((response: AxiosResponse) => {
          setContent(response.data);
        });
    }
  }, [params]);
  return (
    <>
      <div className={classes.techListingContainer}>
        <Markdown>{content}</Markdown>
      </div>
    </>
  );
};
export default JetCourierTechListing;

//max-width: 1280px; min-height: calc(100% - 13vh);
